import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@ui/primitives/dialog';
export function KeyboardShortcutsModal(param) {
    let { isOpen, onClose } = param;
    return /*#__PURE__*/ _jsx(Dialog, {
        open: isOpen,
        onOpenChange: onClose,
        children: /*#__PURE__*/ _jsxs(DialogContent, {
            className: "sm:max-w-[500px] text-gray-25 border-gray-700",
            children: [
                /*#__PURE__*/ _jsxs(DialogHeader, {
                    children: [
                        /*#__PURE__*/ _jsx(DialogTitle, {
                            children: "Keyboard Shortcuts"
                        }),
                        /*#__PURE__*/ _jsx(DialogDescription, {
                            children: "Navigate faster with these keyboard shortcuts"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "grid gap-4",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "text-sm font-medium",
                                    children: "Organization Navigation"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "grid gap-2",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-sm text-muted-foreground",
                                                children: "Cycle through organizations"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex items-center gap-1",
                                                children: [
                                                    /*#__PURE__*/ _jsx("kbd", {
                                                        className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                        children: "j"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-muted-foreground",
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ _jsx("kbd", {
                                                        className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                        children: "k"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "text-sm font-medium",
                                    children: "General"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "grid gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "Open search"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("kbd", {
                                                            className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                            children: "Cmd"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-muted-foreground",
                                                            children: "+"
                                                        }),
                                                        /*#__PURE__*/ _jsx("kbd", {
                                                            className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                            children: "k"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "Toggle sidebar"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("kbd", {
                                                            className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                            children: "Cmd"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-muted-foreground",
                                                            children: "+"
                                                        }),
                                                        /*#__PURE__*/ _jsx("kbd", {
                                                            className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                            children: "b"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "Open organization switcher"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("kbd", {
                                                            className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                            children: "Cmd"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-muted-foreground",
                                                            children: "+"
                                                        }),
                                                        /*#__PURE__*/ _jsx("kbd", {
                                                            className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                            children: "Shift"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-muted-foreground",
                                                            children: "+"
                                                        }),
                                                        /*#__PURE__*/ _jsx("kbd", {
                                                            className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                            children: "o"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "Show keyboard shortcuts"
                                                }),
                                                /*#__PURE__*/ _jsx("kbd", {
                                                    className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                    children: "?"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "text-sm font-medium",
                                    children: "Dropdown Navigation"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "grid gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "Navigate dropdown items"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("kbd", {
                                                            className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                            children: "↑"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-muted-foreground",
                                                            children: "/"
                                                        }),
                                                        /*#__PURE__*/ _jsx("kbd", {
                                                            className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                            children: "↓"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "Select dropdown item"
                                                }),
                                                /*#__PURE__*/ _jsx("kbd", {
                                                    className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                    children: "Enter"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "Close dropdown"
                                                }),
                                                /*#__PURE__*/ _jsx("kbd", {
                                                    className: "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-xs font-medium text-muted-foreground",
                                                    children: "Escape"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
